const map = {
	"./FiraSans-Bold.ttf": 89521,
	"./FiraSans-Medium.ttf": 21205,
	"./FiraSans-Regular.ttf": 12904,
	"./FiraSans-SemiBold.ttf": 87099,
	"./KumbhSans-Bold.ttf": 65800,
	"./KumbhSans-Light.ttf": 75175,
	"./KumbhSans-Regular.ttf": 5039,
	"./NotoEmoji.ttf": 82170,
	"./NotoSerif-Regular.ttf": 66308,
	"./Quicksand-Bold.ttf": 98187,
	"./Quicksand-Light.ttf": 99514,
	"./Quicksand-Medium.ttf": 64479,
	"./Quicksand-Regular.ttf": 79666,
	"./Quicksand-SemiBold.ttf": 83809,
	"./Roboto-Black.ttf": 42659,
	"./Roboto-BlackItalic.ttf": 63387,
	"./Roboto-Bold.ttf": 61491,
	"./Roboto-BoldItalic.ttf": 9707,
	"./Roboto-Italic.ttf": 31394,
	"./Roboto-Light.ttf": 40834,
	"./Roboto-LightItalic.ttf": 14542,
	"./Roboto-Medium.ttf": 8791,
	"./Roboto-MediumItalic.ttf": 7375,
	"./Roboto-Regular.ttf": 76826,
	"./Roboto-Thin.ttf": 43567,
	"./Roboto-ThinItalic.ttf": 55703,
	"./SeptemberMornings.ttf": 72084,
	"fonts/FiraSans-Bold.ttf": 89521,
	"fonts/FiraSans-Medium.ttf": 21205,
	"fonts/FiraSans-Regular.ttf": 12904,
	"fonts/FiraSans-SemiBold.ttf": 87099,
	"fonts/KumbhSans-Bold.ttf": 65800,
	"fonts/KumbhSans-Light.ttf": 75175,
	"fonts/KumbhSans-Regular.ttf": 5039,
	"fonts/NotoEmoji.ttf": 82170,
	"fonts/NotoSerif-Regular.ttf": 66308,
	"fonts/Quicksand-Bold.ttf": 98187,
	"fonts/Quicksand-Light.ttf": 99514,
	"fonts/Quicksand-Medium.ttf": 64479,
	"fonts/Quicksand-Regular.ttf": 79666,
	"fonts/Quicksand-SemiBold.ttf": 83809,
	"fonts/Roboto-Black.ttf": 42659,
	"fonts/Roboto-BlackItalic.ttf": 63387,
	"fonts/Roboto-Bold.ttf": 61491,
	"fonts/Roboto-BoldItalic.ttf": 9707,
	"fonts/Roboto-Italic.ttf": 31394,
	"fonts/Roboto-Light.ttf": 40834,
	"fonts/Roboto-LightItalic.ttf": 14542,
	"fonts/Roboto-Medium.ttf": 8791,
	"fonts/Roboto-MediumItalic.ttf": 7375,
	"fonts/Roboto-Regular.ttf": 76826,
	"fonts/Roboto-Thin.ttf": 43567,
	"fonts/Roboto-ThinItalic.ttf": 55703,
	"fonts/SeptemberMornings.ttf": 72084
};


function webpackContext(req) {
	const id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		const e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 73531;